export const INTERNAL_SERVER_FAILURE = 'INTERNAL_SERVER_FAILURE';
